import { render } from "./GasPreset.vue?vue&type=template&id=f192826c"
import script from "./GasPreset.vue?vue&type=script&lang=js"
export * from "./GasPreset.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__